import React from 'react';
import { getStatusColor } from '../../../utils';
import { useTheme } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
import startCase from 'lodash.startcase';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: Theme) => ({
  root: { display: 'flex', alignItems: 'center' },
  lineIconContainer: {
    width: 20,
    minWidth: 20,
    height: 20,
    borderRadius: '100%',
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clickable: {
    cursor: 'pointer',
    '&:hover': {
      '& .MuiTypography-root': {
        textDecoration: 'underline',
      },
    },
    '& .MuiTypography-root': {
      cursor: 'pointer',
    },
  },
  label: {
    cursor: 'default',
  },
}));

export default function Status({
  status,
  label = undefined,
  textClass = '',
  imgClass = '',
  onClick = undefined,
  is8Data = false,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const statusLabel = label ?? startCase(status);
  const statusFolderPath = is8Data ? '/status/8data' : '/status';
  let imageSrc = `${statusFolderPath}/${status}.svg`;
  return (
    <div
      className={`${classes.root} ${onClick ? classes.clickable : ''}`}
      onClick={onClick}
    >
      <div className={`${classes.lineIconContainer} ${imgClass}`}>
        <img src={imageSrc} alt="" />
      </div>
      <Typography
        className={`${classes.label} ${textClass}`}
        style={{
          color: getStatusColor(theme, status),
        }}
        variant="body2"
      >
        {statusLabel}
      </Typography>
    </div>
  );
}
